import { render, staticRenderFns } from "./DecisionDiamondsMenu.vue?vue&type=template&id=5b4a0453"
import script from "./DecisionDiamondsMenu.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports